import React from "react"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

interface FormSubmitButtonProps {
  loading?: boolean
  children: React.ReactNode
  className?: string
  disabled?: boolean
  size?: "default" | "sm" | "lg" | "icon"
}

/**
 * Standardized submit button for all forms.
 * Handles loading state and applies the big industrial look by default.
 */
export function FormSubmitButton({
  loading,
  children,
  className,
  disabled,
  size = "lg",
}: FormSubmitButtonProps) {
  return (
    <Button
      type="submit"
      size={size}
      disabled={loading || disabled}
      className={cn("h-16 w-full bg-primary text-xl text-primary-foreground shadow-lg", className)}
    >
      {loading ? (
        <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
          <span>...</span>
        </>
      ) : (
        children
      )}
    </Button>
  )
}

